// unfortunately we need this to be able to mock the `reload` function in unit
// tests because it is no longer possible to re-assign properties in jsdom:
// @see: https://github.com/facebook/jest/issues/9471#issuecomment-578801017
export function reload() {
  global.document.location.reload();
}
